import { render, staticRenderFns } from "./domesticShipping.pug?vue&type=template&id=5517b5a1&scoped=true&lang=pug&"
import script from "./domesticShipping.ts?vue&type=script&lang=ts&"
export * from "./domesticShipping.ts?vue&type=script&lang=ts&"
import style0 from "./domesticShipping.scss?vue&type=style&index=0&id=5517b5a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517b5a1",
  null
  
)

export default component.exports